import { EGeoActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setRegionId = actionGenerator<EGeoActionType.SetRegionId, number>(EGeoActionType.SetRegionId);
